<template>
    <div class="input-pfs-curveplot-customize">
          <div>
          <v-switch
            v-if="!twoCohorts()"
            v-model="overallCurve"
            :label="buttonText"
            color="red darken-3"
            hide-details
          ></v-switch>
          <!-- <button @click="toggle">{{ buttonText }}</button> -->

    </div>
      <div v-if="twoCohorts()">
      <input type="checkbox" id="discovery" value="discovery" v-model="cohortSelected" />
      <label>&nbsp;Discovery cohort</label>
      <br>
      <input type="checkbox" id="validation" value="validation" v-model="cohortSelected" />
      <label>&nbsp;Validation cohort</label>
    </div>
    <!-- <p>Checked: {{ cohortSelected }}</p> -->
    <br>
      <div v-if="showSlideBar()">
        <div style="margin-bottom: 20px; padding: 10px; background: #ebebeb">
          Dichotomize the selected continuous variable for survival analysis
          <br><br>
          Control the percentile cutoff by the slider below for {{ pfsCurveVarName }} {{ pfsCurveVarOmics }}
        </div>
        <!-- <v-if="showSlideBar()"> -->
          <!-- <p></p> -->
          <br><br>
          
          <v-slider
          v-model="threshold"
          :min="1"
          :max="99"
          :step="1"
          thumb-label="always"
          :thumb-size="36"
          show-ticks="always"
          :tick-labels="tickLabels"
          tick-size="6"
          dense
          color="blue darken-2"
          @change="setThreshold()"
        >
        <!-- <template v-slot:append>
          <v-text-field
            v-model="threshold"
            @change="setThreshold()"
            density="compact"
            type="number"
            variant="outlined"
            hide-details
          ></v-text-field>
        </template> -->
        <!-- <template v-slot:append>
          <v-text-field
            v-model="threshold"
            @change="setThreshold()"
            style="width: 60px"
            type="number"
            variant="outlined"
            hide-details
          ></v-text-field>
        </template> -->
      </v-slider>
      <span class="subheading font-weight-light me-1">Current cutoff:</span>
          <span
            class="subheading font-weight-light me-1"
            v-text="threshold"
          ></span>
          <span class="subheading font-weight-light me-1">%</span>
      </div>

    <!-- <div
      v-if="submitted"
    >
      <v-switch
        v-model="useZScore"
        label="Use z-scores"
        color="red darken-3"
        hide-details
      ></v-switch>
      </div> -->
    </div>
  </template>
  
  <script>
  
  export default {
      components: {  },
      
      name: "input-pfs-curveplot-customize",
      props: ['studySelected'],
  
  
      computed: {
        pfsCurveVarType() { return this.$store.state.PfsCurveplot_varType },
        pfsCurveVarName() { return this.$store.state.PfsCurveplot_varName },
        pfsCurveVarOmics() { return this.$store.state.PfsCurveplot_varOmics },
        pfsCurveData() { return this.$store.state.PfsCurveplot_data },
        geneData() { 
          let geneAndOmics = this.pfsCurveVarName + ' ' + this.pfsCurveVarOmics
          console.log('geneData', this.pfsCurveData[geneAndOmics])
          // let pfs
          if (geneAndOmics in this.pfsCurveData) {
            console.log('geneData', this.pfsCurveData[geneAndOmics])
            let geneVals = Object.values(this.pfsCurveData[geneAndOmics].data).filter(d => (d !== undefined) && (d !== null))
            let sortedGeneVals = geneVals.sort((a, b) => a - b)
            console.log('sortedGeneVals', sortedGeneVals)
            return sortedGeneVals
          } else {
            console.warn('No data for', geneAndOmics)
            return []
          }
        },
        geneDataMin() {
          if (this.geneData.length > 0) {
            return Math.min(...this.geneData).toFixed(3);
          } else {
            return 0;
          }
        },
        geneDataMax() {
          if (this.geneData.length > 0) {
            return Math.max(...this.geneData).toFixed(3);
          } else {
            return 100;
          }
        },
        geneDataStep() {
          if (this.geneData.length > 0) {
            return ((this.geneDataMax - this.geneDataMin) / 10).toFixed(3);
          } else {
            return 1;
          }
        },
        geneDataMedian() {
          if (this.geneData.length > 0) {
            return Math.median(...this.geneData).toFixed(3);
          } else {
            return 100;
          }
        },
        cohortSelected: {
          get() { return this.$store.state.PfsCurveplot_cohortSelected },
          set(v) { 
            // console.log
            this.$store.dispatch(
              'setViewAttr', { 
                view: 'PfsCurveplot',
                attrKey: 'cohortSelected',
                attrVal: v 
              }
            )}
        },
        buttonText() {
          return this.overallCurve ? 'Switch to Progression-free Survival Curve' : 'Switch to Overall Survival Curve';
        }
        // genes() { return this.$store.state.Scatterplot_genes },
        // geneA() { return this.genes[0] },
        // geneB() { return this.genes[1] },
        // geneATracks() {
        //   return Object.fromEntries(Object.entries(this.trackData).filter(([track, data]) => {
        //     return track.split(' ')[0] === this.geneA
        //   }))
        // },
        // geneATrackList() { 
        //   console.log(this.$store.state.Scatterplot_data )
        //   console.log('scatterplot geneA list', this.geneATracks)
        //   return Object.keys(this.geneATracks) 
        // },
        // geneBTracks() {
        //   return Object.fromEntries(Object.entries(this.trackData).filter(([track, data]) => {
        //     return data.gene === this.geneB
        //   }))
        // },
        // geneBTrackList() { return Object.keys(this.geneBTracks) },
        // trackData() { 
        //   return this.$store.state.Scatterplot_data 
        // },
        // useZScore: {
        //   get() { return this.$store.state.Scatterplot_useZScore },
        //   set(v) { 
        //     this.$store.dispatch(
        //       'setUseZScore',
        //       { 
        //         view: 'Scatterplot',
        //         useZScore: v 
        //       }
        //     )}
        // },
        // valid() { return this.geneATrack.length > 0 && this.geneBTrack.length > 0 },
      },
      
      data: () => ({
        loading: false,
        overallCurve: false,
        // pfsCurveVarOmics: '',
        threshold: 50, // Default threshold value

        // geneATrack: '',
        // geneBTrack: '',
        // submitted: false,
      }),
  
      methods: {
        showSlideBar() {
          return this.pfsCurveVarType === 'Genes';
        },
        setThreshold() {
          console.log('setThreshold', this.threshold)
          this.$store.dispatch('setViewAttr', { 
            view: 'PfsCurveplot',
            attrKey: 'contThresh',
            attrVal: this.threshold
          })
        },
        twoCohorts() {
            return this.studySelected === 'PTRC'
        },
        setOverallCurveBool() {
          this.$store.dispatch('setViewAttr', { 
            view: 'PfsCurveplot',
            attrKey: 'overallCurve',
            attrVal: this.overallCurve
          })
        },
        toggle() {
          this.overallCurve = !this.overallCurve;
          this.setOverallCurveBool()
          // this.$store.dispatch('setViewAttr', { 
          //   view: 'PfsCurveplot',
          //   attrKey: 'overallCurve',
          //   attrVal: this.overallCurve
          // })
        },
        // setOverallCurveBool() {
        //   this.$store.dispatch('setViewAttr', { 
        //     view: 'PfsCurveplot',
        //     attrKey: 'overallCurve',
        //     attrVal: this.overallCurve
        //   })
        // }
        
        // setScatterplotTracks() {
        //   this.$store.dispatch('setScatterplotTracks', {
        //     Scatterplot_tracks: [ this.geneATrack, this.geneBTrack ] 
        //   })
        //   this.submitted = true
        // },
        // varDataTypeContinuous() {
        //     console.log('test pfs customize', this.pfsCurveVarType)
        //   if (this.pfsCurveVarType === 'Genes') {
        //     console.log('test pfs customize genes', this.pfsCurveVarType)
        //     return true
        //   } else {
        //     return false
        //   }
        // },
      },
  
      watch: {
        varDataTypeContinuous() {
            console.log('test pfs customize', this.pfsCurveVarType)
          if (this.pfsCurveVarType === 'Genes') {
            console.log('test pfs customize genes', this.pfsCurveVarType)
            return true
          } else {
            return false
          }
        },
        studySelected() { this.setOverallCurveBool() },
        overallCurve() { this.setOverallCurveBool() },
      },
  
      mounted() { 
  
      }
  }
  </script>
  
  <style>
  .input-pfs-curveplot-customize {
      margin-top: 40px;
      padding: 10px;
  }
  
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  .ttest-descriptor {
    width: 100%;
    margin: 10px;
    font-size: 0.8em;
  }

  .min-value {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}

.max-value {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}


  </style>